import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { InfoText, InfoTitle, InfoWrapper } from 'components/new-ui/base/info-wrapper/styles';
import useManifests from 'hooks/useManifests';
import useJobs from 'hooks/useJobs';
import Button from 'components/new-ui/base/button/Button';
import AssignJobModal from 'views/manifests/components/AssignJobModal';
import { StyledPaperRow } from 'components/new-ui/base/wrappers/styles';

type Props = {
    canAssignJobs: boolean;
};

const ManifestJobOverviewHeader = ({ canAssignJobs }: Props) => {
    const { jobId } = useParams<{ jobId: string }>();
    const { manifest } = useManifests();
    const { job, getJob } = useJobs({ jobId, autoFetch: false });

    const [openAssignModal, setOpenAssignModal] = useState(false);

    let assignedTo: React.ReactNode = '-';

    if (job?.owner?.fullName) {
        assignedTo = job?.owner.fullName;
    } else if (job?.owner?.email) {
        assignedTo = job?.owner.email;
    } else if (canAssignJobs) {
        assignedTo = <Button type="assign" onClick={() => setOpenAssignModal(true)} />;
    }

    const headerData: Array<{ label: string; value: string | React.ReactNode }> = [
        {
            label: 'Trailer No.',
            value: manifest?.declarationsData?.vehicleRegistration ?? '-',
        },
        {
            label: 'Internal Ref',
            value: manifest?.referenceId ?? '-',
        },
        {
            label: 'UK Export MRN',
            value: job?.externalReferences?.cdsExportMRN ?? '-',
        },
        {
            label: 'Customer',
            value: job?.customer?.name ?? '-',
        },
        {
            label: 'INCOTERM',
            value: job?.incotermCode ?? '-',
        },
        {
            label: 'Declarant',
            value: job?.creator?.fullName ?? job?.creator?.email ?? '-',
        },
        {
            label: 'Assigned To',
            value: assignedTo,
        },
    ];

    return (
        <>
            <StyledPaperRow justify="space-between">
                {headerData.map(({ label, value }) => (
                    <InfoWrapper key={label}>
                        <InfoTitle>{label}:</InfoTitle>
                        <InfoText>{value}</InfoText>
                    </InfoWrapper>
                ))}
            </StyledPaperRow>

            {job && (
                <AssignJobModal
                    open={openAssignModal}
                    jobData={{
                        jobId: job.id,
                        teamId: job.teamId,
                    }}
                    onClose={() => setOpenAssignModal(false)}
                    onSuccess={() => {
                        setOpenAssignModal(false);
                        getJob(job.id);
                    }}
                />
            )}
        </>
    );
};

export default ManifestJobOverviewHeader;
